import React from 'react';
import { Circle } from 'lucide-react';

const AdminChatItem = ({ chat, isSelected, onSelect }) => {
  const formatTime = (date) => {
    const now = new Date();
    const messageDate = new Date(date);
    const diffInMinutes = Math.floor((now - messageDate) / 60000);

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return messageDate.toLocaleDateString();
  };

  // Check if there are unread messages from user
  const hasUnreadFromUser = (chat.unreadCount || 0) > 0;

  return (
    <button
      className={`list-group-item list-group-item-action border-0 ${
        isSelected ? 'active' : ''
      }`}
      onClick={onSelect}
      style={{
        backgroundColor: isSelected ? '#667eea' : 'transparent',
        color: isSelected ? 'white' : 'inherit',
        cursor: 'pointer',
        transition: 'all 0.2s',
      }}
    >
      <div className='d-flex align-items-start gap-3'>
        {/* Chat Info */}
        <div className='flex-grow-1 overflow-hidden'>
          <div className='d-flex justify-content-between align-items-start mb-1'>
            <div className='d-flex align-items-center gap-2'>
              <h6
                className={`mb-0 fw-semibold ${
                  isSelected ? 'text-white' : 'text-dark'
                }`}
              >
                {chat.user?.fullName || 'Guest'}
              </h6>
              {hasUnreadFromUser && (
                <span
                  className='badge rounded-pill'
                  style={{
                    backgroundColor: isSelected ? '#fff' : '#22c55e',
                    color: isSelected ? '#667eea' : '#fff',
                    fontSize: '0.65rem',
                    padding: '0.25rem 0.5rem',
                  }}
                >
                  {chat.unreadCount > 1 ? chat.unreadCount : 'New'}
                </span>
              )}
            </div>
            <small className={isSelected ? 'text-white-50' : 'text-muted'}>
              {formatTime(
                chat.messages?.[0]?.createdAt ||
                  chat.updatedAt ||
                  chat.createdAt
              )}
            </small>
          </div>

          {chat.messages && chat.messages.length > 0 && (
            <p
              className={`mb-0 mt-1 text-truncate small ${
                isSelected ? 'text-white-50' : 'text-muted'
              }`}
            >
              {chat.messages[0].message}
            </p>
          )}
        </div>
      </div>

      {/* Online Status Indicator */}
      {chat.isOnline && (
        <Circle
          size={10}
          className='position-absolute'
          style={{
            top: '15px',
            left: '50px',
            fill: '#22c55e',
            stroke: '#22c55e',
          }}
        />
      )}
    </button>
  );
};

export default AdminChatItem;
